module.exports = __webpack_public_path__ + "img/years-in-business.7e53d3f.png";